const DEFAULT_VIEWPORT_PADDING = 16;
const DEFAULT_ANCHOR_PADDING = 16;

function clamp(value, min, max) {
	return Math.min(Math.max(value, min), max);
}

/**
 * Calculate a dialog width and left edge around the center of a target area.
 * The target can be narrower than the viewport (for example, the chat content
 * area while the group information panel is open).
 */
export function getAnchoredDialogLayout(anchorRect, preferredWidth, viewportWidth) {
	const safeViewportWidth = Math.max(1, Number(viewportWidth) || 1);
	const rawAnchorLeft = Number(anchorRect && anchorRect.left) || 0;
	const rawAnchorWidth = Math.max(1, Number(anchorRect && anchorRect.width) || safeViewportWidth);
	const visibleAnchorLeft = clamp(rawAnchorLeft, 0, safeViewportWidth);
	const visibleAnchorRight = clamp(rawAnchorLeft + rawAnchorWidth, 0, safeViewportWidth);
	const visibleAnchorWidth = Math.max(1, visibleAnchorRight - visibleAnchorLeft);
	const availableWidth = Math.max(1, Math.min(
		visibleAnchorWidth - DEFAULT_ANCHOR_PADDING * 2,
		safeViewportWidth - DEFAULT_VIEWPORT_PADDING * 2
	));
	const width = Math.max(1, Math.min(Number(preferredWidth) || availableWidth, availableWidth));
	const centeredLeft = rawAnchorLeft + (rawAnchorWidth - width) / 2;
	const maxLeft = Math.max(DEFAULT_VIEWPORT_PADDING, safeViewportWidth - width - DEFAULT_VIEWPORT_PADDING);
	const left = clamp(centeredLeft, DEFAULT_VIEWPORT_PADDING, maxLeft);

	return {
		width: Math.round(width),
		left: Math.round(left)
	};
}

export function findVisibleDialogAnchor(selector) {
	if (!selector || typeof document === 'undefined') {
		return null;
	}

	try {
		return Array.from(document.querySelectorAll(selector)).find((element) => {
			const rect = element.getBoundingClientRect();
			return rect.width > 0 && rect.height > 0;
		}) || null;
	} catch (error) {
		return null;
	}
}

export function applyDialogLeft(root, left) {
	if (!root) {
		return;
	}
	const dialog = root.matches && root.matches('.el-dialog')
		? root
		: root.querySelector && root.querySelector('.el-dialog');
	if (!dialog) {
		return;
	}

	// Element UI centers with margin:auto. An explicit margin aligns the dialog
	// with the selected content area; reset left so a previous drag does not leak
	// into the next opening or a resized layout.
	dialog.style.left = '0px';
	dialog.style.marginLeft = `${left}px`;
	dialog.style.marginRight = '0';
}
